import Routes from '../routes.mjs';
import replaceRoute from './replaceRoute';

const redirectToRoute = (route, query, response, statusCode = 301) => {
  if (response) {
    if (!response.finished) {
      response.writeHead(statusCode, {
        Location: Routes.findAndGetUrls(
          route,
          query,
        ).urls.as,
      });
      response.end();
    }
  } else {
    replaceRoute(route, query);
  }
  return {};
};

export default redirectToRoute;
